/** `sub_vendor_id` query param: omit / -1 = all, 0 = no sub assigned yet. */
export const SUB_VENDOR_FILTER_ALL = -1
export const SUB_VENDOR_FILTER_UNASSIGNED = 0
